import React from "react";
import PropTypes from "prop-types";
import socialLinkType from "./types/socialLinkType";
import glassdoorIcon from "./img/glassdoorIcon.svg";
import glassdoorHoverIcon from "./img/glassdoorHoverIcon.svg";
import {
  SocialLinksWrapper,
  SocialLink,
  FontAwesome,
  GlassdoorIcon,
  GlassdoorLink,
} from "./styles/social-links-styles";

const handleOnMouseEnter = (e) => {
  e.target.src = glassdoorHoverIcon;
};

const handleOnMouseLeave = (e) => {
  e.target.src = glassdoorIcon;
};

const SocialLinks = ({ socialLinks, glassDoorLink }) => (
  <SocialLinksWrapper>
    {socialLinks.map((socialLink) => (
      <SocialLink
        key={socialLink.id}
        href={socialLink.link}
        title={socialLink.link}
        target="_blank"
        isTwitter={socialLink.id === "tw"}
      >
        <FontAwesome className={socialLink.icon} aria-hidden="true" />
      </SocialLink>
    ))}
    {glassDoorLink && (
      <GlassdoorLink href={glassDoorLink} target="_blank">
        <GlassdoorIcon
          src={glassdoorIcon}
          onMouseEnter={handleOnMouseEnter}
          onMouseLeave={handleOnMouseLeave}
          alt="Glassdoor"
        />
      </GlassdoorLink>
    )}
  </SocialLinksWrapper>
);

SocialLinks.propTypes = {
  socialLinks: PropTypes.arrayOf(socialLinkType).isRequired,
  glassDoorLink: PropTypes.string,
};

SocialLinks.defaultProps = {
  glassDoorLink: PropTypes.isNull,
};

export default React.memo(SocialLinks);
